import React from 'react';
import { PageHeader } from '../components/layout/PageHeader';
import { InfoCardGrid } from '../components/sections/InfoCardGrid';
import { technicalFeatures } from '../data/technicalMastery';
export function TechnicalMasteryPage() {
  return <div data-id="element-268" data-mp="203scyk0la4fb">
      <PageHeader eyebrow="Technical Mastery & Systems Portfolio" title="Enterprise Technology Deployments & Digital Platforms" data-id="element-269" data-mp="202z4nelzf6v2" />
      <section className="bg-white pb-20 lg:pb-28" data-id="element-270" data-mp="29ttoydfo3wdv">
        <div className="mx-auto max-w-7xl px-6 lg:px-10" data-id="element-271" data-mp="29x941g9cd5fa">
          <InfoCardGrid items={technicalFeatures} columns={2} data-id="element-272" data-mp="2esogc3rpat9l" />
        </div>
      </section>
    </div>;
}